(function ($) {
  Drupal.behaviors.ehThewinkHpRedesignQuotesV1 = {
    attach: function (context, settings) {
      var formatter = $('.eh-thewink-hp-redesign-quotes-v1', context);

      formatter.each(function () {
        var thisFormatter = $(this);

        // Lazyload
        site.util.lazyLoaded(thisFormatter);
      });
    }
  };
})(jQuery);
